import { Button } from '@/components/Button';
import { Card, CardContent } from '@/components/Card';

export default function Login({ flash, errors = {} }) {
  const handleGoogleLogin = () => {
    window.location.href = '/auth/google_oauth2';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Left Column: Brand & Hero */}
      <div className="hidden lg:flex w-1/2 bg-bambu-dark-green relative overflow-hidden flex-col justify-between p-12 text-white">
        {/* Abstract Shapes/Pattern Overlay */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-[-20%] left-[-20%] w-[80%] h-[80%] rounded-full bg-bambu-green blur-[100px]"></div>
          <div className="absolute bottom-[-20%] right-[-20%] w-[60%] h-[60%] rounded-full bg-emerald-500 blur-[80px]"></div>
        </div>

        {/* Top: Logo Text */}
        <div className="relative z-10">
          <h2 className="text-2xl font-bold tracking-tight">bambúcode</h2>
        </div>

        {/* Middle: Hero Content */}
        <div className="relative z-10 max-w-lg">
          <h1 className="text-5xl font-black mb-6 leading-tight">
            Celebra los <span className="text-bambu-green">logros</span>,<br />
            construye <span className="text-emerald-400">cultura</span>.
          </h1>
          <p className="text-xl text-gray-300 font-light">
            La plataforma donde el reconocimiento impulsa el crecimiento de cada miembro del equipo.
          </p>
        </div>

        {/* Bottom: Footer Info */}
        <div className="relative z-10 text-sm text-gray-400 font-medium">
          {/* <p>Version 2.0.0 &bull; Rails Monolith</p> */}
        </div>
      </div>

      {/* Right Column: Form */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center p-6 bg-white relative">
        {/* Mobile Header (Only visible on small screens) */}
        <div className="lg:hidden w-full max-w-md mb-8 text-center">
          <h1 className="text-3xl font-black text-bambu-dark-green">bambonus</h1>
          <p className="text-gray-400">bambúcode</p>
        </div>

        <div className="w-full max-w-md">
          <Card className="w-full border-none shadow-none lg:shadow-xl bg-transparent lg:bg-white overflow-hidden rounded-3xl">
            {/* Unified Header Section within the Card */}
            <div className="pt-10 pb-2 flex flex-col items-center text-center">
              {/* Logo - No box/container as requested */}
              <img
                src="/favicon.png"
                alt="Bambu Logo"
                className="w-16 h-16 object-contain mb-4 drop-shadow-sm hover:scale-105 transition-transform duration-500"
              />
              <h1 className="text-3xl font-black text-bambu-black tracking-tight mb-1">bambonus</h1>
              <p className="text-gray-400 text-sm font-medium">Reconoce. Comparte. Crece.</p>
            </div>

            <CardContent className="p-8 pt-6">
              {(errors.alert || errors.error || flash?.alert) && (
                <div className="p-3 mb-5 bg-red-50 border border-red-100 text-red-600 rounded-xl text-xs font-bold flex items-center animate-in fade-in slide-in-from-top-2">
                  <span className="mr-2 text-lg">⚠️</span> {errors.alert || errors.error || flash?.alert}
                </div>
              )}

              <div className="space-y-4">
                <Button
                  type="button"
                  className="w-full h-14 border-2 border-gray-200 bg-white hover:bg-gray-50 hover:border-bambu-green/30 hover:shadow-lg transition-all duration-200 font-bold text-gray-700 rounded-xl flex items-center justify-center gap-3"
                  onClick={handleGoogleLogin}
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24">
                    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                  </svg>
                  Continuar con Google
                </Button>

                <p className="text-center text-xs text-gray-400 mt-6 leading-relaxed">
                  Inicia sesión con tu cuenta de <span className="font-semibold text-bambu-dark-green">@bambucode.com</span> para acceder a la plataforma
                </p>
              </div>
            </CardContent>
          </Card>

          <p className="mt-8 text-center text-xs font-semibold text-gray-300 tracking-wide">
            © {new Date().getFullYear()} bambúcode
          </p>
        </div>
      </div>
    </div>
  );
}
